<template>
  <v-container fluid full-height grid-list-md>
    <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="onSave">
      <v-layout row wrap>
        <v-flex xs6>
          <div class="text-xs-left">
            <v-breadcrumbs :items="breadcrumbs" divider=">">
              <template slot="item" slot-scope="props">
                <router-link
                  :to="'/' + props.item.to"
                  :disabled="props.item.disabled"
                  v-bind:class="{
                    'v-breadcrumbs__item v-breadcrumbs__item--disabled':
                      props.item.disabled,
                  }"
                  >{{ props.item.text }}</router-link
                >
              </template>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs6>
          <div class="text-xs-right">
            <v-btn outline color="primary" @click="goBack">
              Go Back
              <v-icon right>arrow_back</v-icon>
            </v-btn>
          </div>
        </v-flex>
        <v-flex>
          <v-card>
            <v-layout row wrap class="pa-3">
              <v-flex sm6>
                <v-text-field
                  name="code"
                  label="Code"
                  v-model="supplier.code"
                  type="text"
                  :rules="rules.codeRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="companyName"
                  label="Company Name"
                  v-model="supplier.companyName"
                  type="text"
                  :rules="rules.companyNameRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="phone"
                  label="Phone No."
                  v-model="supplier.phone"
                  type="text"
                  :rules="rules.phoneRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="email"
                  label="Email"
                  v-model="supplier.email"
                  type="text"
                  :rules="rules.emailRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  name="contactPerson"
                  label="Contact Person"
                  v-model="supplier.contactPerson"
                  type="text"
                  :rules="rules.contactPersonRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-autocomplete
                  v-model="supplier.supplierType"
                  :items="supplierTypeList"
                  :hide-no-data="true"
                  color="blue-grey lighten-2"
                  label="Choose Supplier Type..."
                  item-text="label"
                  item-value="value"
                  menu-props="auto"
                  :rules="rules.supplierTypeRules"
                ></v-autocomplete>
              </v-flex>
              <v-flex
                sm12
                v-if="
                  supplier.supplierType && supplier.supplierType == 'INTERNAL'
                "
              >
                <v-select
                  :items="warehouseList"
                  v-model="supplier.warehouseId"
                  label="Select Warehouse"
                  item-text="name"
                  item-value="id"
                  :rules="rules.warehouseRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-select
                  :items="creditLevelList"
                  v-model="supplier.creditLevelId"
                  label="Choose Credit Level"
                  item-text="name"
                  item-value="id"
                  menu-props="auto"
                  :rules="rules.creditLevelRules"
                ></v-select>
              </v-flex>
              <v-flex sm12>
                <v-text-field
                  name="address"
                  label="Address"
                  v-model="supplier.address"
                  type="text"
                  :rules="rules.addressRules"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Account Code"
                  v-model="supplier.accountCode"
                  @click="showAccounts()"
                  :rules="rules.codeRules"
                  :readonly="true"
                ></v-text-field>
              </v-flex>
              <v-flex sm6>
                <v-text-field
                  label="Account Name"
                  v-model="supplier.accountName"
                  :readonly="true"
                ></v-text-field>
              </v-flex>

              <v-flex sm12>
                <v-label>Attach File</v-label>
                <input
                  type="file"
                  id="files"
                  ref="files"
                  v-on:change="onChangeFileUpload"
                  multiple
                  accept=".pdf, .png, .jpg, .jpeg, .docx, .xlsx"
                />
              </v-flex>
              <v-flex sm12>
                <div
                  v-for="(supplierAttachment, key) in supplierAttachments"
                  :key="key"
                >
                  <a
                    v-text="supplierAttachment.fileName"
                    @click.prevent="downloadFile(supplierAttachment)"
                  />
                  <span v-if="supplier.id">
                    <v-btn icon @click="removeFile(key, supplierAttachment.id)">
                      <v-icon color="red">cancel</v-icon>
                    </v-btn>
                  </span>
                </div>
              </v-flex>

              <v-flex v-if="supplier.id">
                <!-- products -->
                <v-layout row wrap>
                  <v-btn color="success" @click="showProducts()">
                    Add Product
                    <v-icon right>add</v-icon>
                  </v-btn>
                </v-layout>
                <v-card>
                  <v-card-title>
                    <v-flex xs4>
                      <v-text-field
                        v-model="detailCodeSearch"
                        append-icon="search"
                        placeholder="Enter product code"
                        label="Search"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-flex>
                  </v-card-title>

                  <v-data-table
                    :headers="detailHeaders"
                    :items="detailList"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.productCode }}</td>
                      <td>{{ props.item.productName }}</td>
                      <td>{{ props.item.factorUnitName }}</td>
                      <td>{{ props.item.unitCost }}</td>
                      <td>{{ props.item.currencyCode }}</td>
                      <td>{{ props.item.exchangeRate }}</td>
                      <td>{{ props.item.unitCostMMK }}</td>
                      <td>
                        <v-layout>
                          <v-btn
                            flat
                            icon
                            color="blue lighten-2"
                            @click="editDetail(props.item)"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>
                          <v-flex pt-2>
                            <v-icon
                              v-if="props.item.status == 'ACTIVE'"
                              medium
                              color="green"
                              >check_circle
                            </v-icon>
                            <v-icon v-else medium color="red">cancel</v-icon>
                          </v-flex>
                        </v-layout>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>

              <v-flex sm12>
                <div class="text-xs-center">
                  <v-btn color="error" @click="clear" 
                    :disabled="
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'WAREHOUSE_STAFF'
                    ">
                    Reset
                    <v-icon right>clear</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    :loading="saveLoading"
                    :disabled="
                      !valid ||
                      user.role.roleName == 'WAREHOUSE_MANAGER' ||
                      user.role.roleName == 'WAREHOUSE_STAFF'
                    "
                    type="submit"
                  >
                    Save
                    <v-icon right>save</v-icon>
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-form>

    <!-- supplier product dialog -->
    <v-dialog
      v-model="showSupplierProductDialog"
      scrollable
      max-width="1000px"
      persistent
    >
      <v-form ref="detailForm" v-model="supplierProductValid">
        <v-card>
          <v-card-title>
            <v-layout wrap>
              <v-flex sm12 v-if="detailResponseError">
                <span class="red--text">* {{ detailResponseError }}</span>
              </v-flex>
              <v-flex xs12 sm6 md2>
                <v-text-field
                  name="supplierName"
                  label="Supplier Name"
                  type="text"
                  class="mr-1"
                  v-model="supplier.companyName"
                  readonly
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-flex xs12 class="mt-1">
              <v-card>
                <v-flex row wrap class="pa-3">
                  <v-layout row wrap class="light--text">
                    <v-flex xs1>Code</v-flex>
                    <v-flex xs3>Product</v-flex>
                    <v-flex xs2>Unit</v-flex>
                    <v-flex xs1>Unit Cost</v-flex>
                    <v-flex xs1>Currency</v-flex>
                    <v-flex xs1>Exchange Rate</v-flex>
                    <v-flex xs2>Unit Cost MMK</v-flex>
                    <v-flex xs1 v-if="supplierProduct.id">Status</v-flex>
                  </v-layout>
                  <v-divider></v-divider>
                  <v-layout>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        placeholder="Product Code"
                        v-model="supplierProduct.productCode"
                        :rules="rules.codeRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs3 pr-2>
                      <v-text-field
                        v-model="supplierProduct.productName"
                        :rules="rules.nameRules"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-autocomplete
                        v-model="supplierProduct.factorUnitName"
                        :hide-no-data="true"
                        :items="supplierProduct.productUnits"
                        color="blue-grey lighten-2"
                        item-value="factorUnitName"
                        item-text="factorUnitName"
                        @change="(option) => initPrice(option)"
                        menu-props="auto"
                        label="Select"
                        :rules="rules.unitRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="supplierProduct.unitCost"
                        min="0"
                        @input="calculateUnitCostMMK"
                        :rules="rules.unitCostRules"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-autocomplete
                        v-model="supplierProduct.currencyId"
                        :items="currencyList"
                        menu-props="auto"
                        item-text="code"
                        item-value="id"
                        @change="changeCurrency"
                        :rules="rules.currencyRules"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs1 pr-2>
                      <v-text-field
                        v-model="supplierProduct.exchangeRate"
                        min="0"
                        :error-messages="currencyExchangeError"
                        :loading="currencyExchangeLoading"
                        @input="calculateUnitCostMMK"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs2 pr-2>
                      <v-text-field
                        v-model="supplierProduct.unitCostMMK"
                        readonly
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs1 pr-2 v-if="supplierProduct.id">
                      <v-switch
                        v-model="supplierProduct.statusFlag"
                        @change="changeStatus"
                      ></v-switch>
                    </v-flex>
                  </v-layout>
                  <v-flex xs12>
                    <div class="text-xs-center">
                      <v-btn color="error" @click="cancel">
                        Cancel
                        <v-icon right>clear</v-icon>
                      </v-btn>
                      <v-btn
                        color="primary"
                        :loading="saveSupplierProductLoading"
                        :disabled="
                          !supplierProductValid ||
                          user.role.roleName == 'WAREHOUSE_MANAGER' ||
                          user.role.roleName == 'WAREHOUSE_STAFF'
                        "
                        @click.stop="saveDetail"
                      >
                        Save
                        <v-icon right>save</v-icon>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-flex>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- final message dialog -->
    <v-dialog
      v-model="messageDialogBox"
      max-width="500px"
      @keydown.enter="messageDialogBox = false"
    >
      <v-card>
        <v-card-text>
          <v-flex>
            <v-alert type="error" :value="true">
              <h3>{{ responseError }}</h3>
            </v-alert>
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" flat @click="messageDialogBox = false"
            >Close</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Product list dialog -->
    <v-dialog v-model="showProductListDialog" scrollable max-width="1000px">
      <v-card>
        <v-card-title>
          <!-- Search Section -->
          <v-layout wrap>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="code"
                label="Code"
                type="text"
                class="mr-1"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="name"
                label="Name"
                type="text"
                class="mr-1"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="brandName"
                label="Brand"
                type="text"
                class="mr-1"
                v-model="queryParams.brandName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="categoryName"
                label="Category"
                type="text"
                class="mr-1"
                v-model="queryParams.categoryName"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6 md2>
              <v-text-field
                name="productGroupName"
                label="Product Group"
                type="text"
                class="mr-1"
                v-model="queryParams.productGroupName"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <!-- Product List Section -->
          <v-flex xs12 class="mt-1">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="productList"
                class="elevation-1"
                :loading="showListLoading"
                :total-items="totalRows"
                :rows-per-page-items="rowsPerPageItems"
                :pagination.sync="pagination"
                :must-sort="true"
              >
                <template slot="items" slot-scope="props">
                  <td
                    @click="
                      setProduct(props.item.code),
                        (showProductListDialog = !showProductListDialog)
                    "
                  >
                    <a>{{ props.item.code }}</a>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>{{ props.item.brand.name }}</td>
                  <td>{{ props.item.category.name }}</td>
                  <td v-if="props.item.productGroup">
                    {{ props.item.productGroup.name }}
                  </td>
                  <td v-else></td>
                  <td>{{ props.item.description }}</td>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>

    <account-list-dialog
      :showDialog="accountListDialog"
      :params="{ isParent: false }"
      @close="closeAccountDialog"
    ></account-list-dialog>
  </v-container>
</template>

<script>
import { supplierService } from "../../services/supplier-service";
import { warehouseService } from "../../services/warehouse-service";
import { Supplier } from "../../models/model";
import { SupplierProduct } from "../../models/model";
import { commonService } from "../../services/common-service";
import VSwitch from "vuetify/lib/components/VSwitch/VSwitch";
import { SupplierFormRules } from "../../helpers/validation-rules";
import { productService } from "../../services/product-service";
import { currencyService } from "../../services/currency-service";
import AccountListDialog from "../dialogs/AccountListDialog.vue";
import { currencyExchangeRateService } from "../../services/currency-exchange-rate-service";
import { creditLevelService } from '../../services/credit-level-service';

export default {
  name: "SupplierDetail",
  components: { VSwitch, AccountListDialog },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    valid: true,
    supplierProductValid: true,
    breadcrumbs: [
      {
        text: "Supplier",
        disabled: false,
        to: "suppliers",
      },
      {
        text: "Supplier Detail",
        disabled: true,
      },
    ],
    warehouseId: "",
    fromWarehouseId: "",
    toWarehouseId: "",
    issueDate: "",
    fromWarehouseName: "",
    responseError: "",
    currencyList: [],
    creditLevelList: [],
    defaultCurrencyId: "",
    messageDialogBox: false,
    supplier: new Supplier(),
    supplierProduct: new SupplierProduct(),
    oldSupplier: new Supplier(),
    saveLoading: false,
    statusList: [],
    warehouseList: [],
    productList: [],
    rules: new SupplierFormRules(),
    showProductListDialog: false,
    headers: [
      { text: "Code", value: "code" },
      { text: "Name", align: "left", value: "name" },
      { text: "Brand", value: "brand.name" },
      { text: "Category", value: "category.name" },
      { text: "Product Group", value: "productGroup.name" },
      { text: "Description", value: "description" },
    ],
    supplierTypeList: [
      { label: "INTERNAL", value: "INTERNAL" },
      { label: "EXTERNAL", value: "EXTERNAL" },
    ],
    rowsPerPageItems: [10, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: "code",
      totalItems: 0,
    },
    totalRows: 0,
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE",
      brandName: "",
      categoryName: "",
      productGroupName: "",
      supplierType: "",
      warehouseId: "",
    },
    search: null,
    code: "",
    showListLoading: false,
    selectedId: 0,

    detailCodeSearch: "",
    detailHeaders: [
      { text: "Code", align: "left", sortable: false },
      { text: "Product", align: "left", sortable: false },
      { text: "Unit", align: "left", sortable: false },
      { text: "Unit Cost", align: "left", sortable: false },
      { text: "Currency", align: "left", sortable: false },
      { text: "Exchange Rate", align: "left", sortable: false },
      { text: "Unit Cost MMK", align: "left", sortable: false },
      { text: "Actions", align: "left", sortable: false },
    ],
    detailResponseError: "",
    showSupplierProductDialog: false,
    saveSupplierProductLoading: false,
    accountListDialog: false,
    currencyExchangeLoading: false,
    currencyExchangeError: "",
    files: [],
    supplierAttachments: [],
  }),
  watch: {
    pagination: {
      handler() {
        this.getProductList();
      },
      deep: true,
    },
  },

  computed: {
    detailList() {
      return this.supplier.supplierProductList.filter((d) => {
        if (this.detailCodeSearch)
          return (
            d.productCode
              .toLowerCase()
              .indexOf(this.detailCodeSearch.toLowerCase()) > -1
          );
        else return true;
      });
    },
  },

  created() {
    this.getCurrencies();
    this.getAllWarehouses();
    this.getCreditLevels();
    const id = this.$route.params.id;
    if (id == "new") {
      // new stockTransfer
      this.issueDate = commonService.formatDate(
        new Date().toISOString().substr(0, 10),
        "YYYY-MM-DD"
      );
    } else {
      this.getSupplierDetail(id);
    }
  },
  methods: {
    getCurrencies() {
      currencyService
        .getCurrencyByStatus("ACTIVE")
        .then((res) => {
          this.currencyList = res.data;
          let currency = commonService.search(
            "defaultCurrency",
            true,
            this.currencyList
          );
          if (currency) this.defaultCurrencyId = currency.id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAllWarehouses() {
      warehouseService
        .getWarehousesByStatus("ACTIVE")
        .then((res) => {
          this.warehouseList = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then(res => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.getProductList();
    },
    onSave() {
      if (this.$refs.form.validate()) {
        this.saveLoading = true;

        // deep copy, and remove unnecessary object
        let supplier = JSON.parse(JSON.stringify(this.supplier));
        supplier.supplierProductList = [];

        supplierService
          .saveSupplier(supplier)
          .then((res) => {
            console.log(res);
            this.supplier.id = res.data.id;
            this.submitForm(this.supplier.id);
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.responseError = err.response.data.message;
              this.messageDialogBox = true;
            }
            this.saveLoading = false;
          });
      }
    },

    submitForm(id) {
      if (this.files) {
        this.saveLoading = true;
        let formData = new FormData();
        for (var i = 0; i < this.files.length; i++) {
          let file = this.files[i];
          console.log(file);
          formData.append("file", file);
        }
        supplierService
          .saveFiles(formData, id)
          .then((res) => {
            this.goBack();
            this.done();
            console.log(res.data);
          })
          .catch((err) => {
            if (err.response) {
              this.responseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveLoading = false;
          });
      }
    },

    onChangeFileUpload(e) {
      this.responseError = "";
      var size = 0;
      this.files = e.target.files;
      if (this.files) {
        for (var i = 0; i < this.files.length; i++) {
          size += this.files[i].size / 1024 / 1024;
        }
      }
      if (size > 30) {
        this.responseError =
          "Upload file size exceeds the maximun upload size!";
      }
    },

    removeFile(index, fileId) {
      if (fileId) {
        // add delete stock in id
        if (!this.supplier.deleteSupplierAttachmentIds) {
          this.supplier.deleteSupplierAttachmentIds = [];
        }
        this.supplier.deleteSupplierAttachmentIds.push(fileId);
      }
      this.$delete(this.supplier.supplierAttachments, index);
    },

    downloadFile(file) {
      supplierService
        .downloadFile(file.id)
        .then(commonService.downloadE)
        .catch((err) => {
          console.error(err);
          if (err.response.data) {
            this.responseError = err.response.data.message;
          }
        });
    },

    getSupplierDetail(id) {
      supplierService
        .getSupplierDetail(id)
        .then((res) => {
          this.supplier = res.data;
          this.supplierAttachments = res.data.supplierAttachments;
          // deep copy
          this.oldSupplier = JSON.parse(JSON.stringify(res.data));
        })
        .catch((err) => {
          console.log(err);
        });
    },

    showProducts() {
      // Clean query params
      this.queryParams.code = "";
      this.queryParams.name = "";
      this.queryParams.brandName = "";
      this.queryParams.categoryName = "";
      this.queryParams.productGroupName = "";

      this.getProductList().then(
        (this.showProductListDialog = !this.showProductListDialog)
      );
    },
    getProductList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      return productService
        .getProductList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then((res) => {
          if (res.data) {
            this.productList = res.data.productList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    setProduct(code) {
      let product = commonService.search("code", code, this.productList);
      this.supplierProduct = new SupplierProduct();
      this.supplierProduct.supplierId = this.supplier.id;
      this.supplierProduct.productId = product.id;
      this.supplierProduct.productCode = product.code;
      this.supplierProduct.productName = product.name;
      this.supplierProduct.productUnits = product.productUnits;
      this.supplierProduct.factorUnitName = "";
      this.detailResponseError = "";
      let pu = commonService.search("basicUnit", true, product.productUnits);
      if (pu) {
        this.supplierProduct.productUnitId = pu.id;
        this.supplierProduct.factorUnitName = pu.factorUnitName;
        this.supplierProduct.unitCost = pu.unitCost;
      }
      this.supplierProduct.currencyId = this.defaultCurrencyId;
      if (this.supplierProduct.currencyId)
        this.getCurrencyExchange(this.supplierProduct.currencyId);
      this.calculateUnitCostMMK();
      this.showSupplierProductDialog = !this.showSupplierProductDialog;
    },
    initPrice(factorUnitName) {
      let productUnit = commonService.search(
        "factorUnitName",
        factorUnitName,
        this.supplierProduct.productUnits
      );
      this.supplierProduct.productUnitId = productUnit.id;
      this.supplierProduct.unitCost = productUnit.unitCost;
      this.calculateUnitCostMMK();
    },
    changeCurrency(currencyId) {
      let currency = commonService.search("id", currencyId, this.currencyList);
      this.supplierProduct.currencyId = currency.id;
      this.supplierProduct.currencyCode = currency.code;
      this.getCurrencyExchange(this.supplierProduct.currencyId);
    },

    clear() {
      this.$refs.form.resetValidation();
      if (!this.supplier.id) {
        this.supplier = new Supplier();
      } else {
        this.supplier = Object.assign({}, this.oldSupplier);
      }
    },
    goBack() {
      this.$router.push("/suppliers");
    },

    saveDetail() {
      if (this.$refs.detailForm.validate()) {
        this.saveSupplierProductLoading = true;
        supplierService
          .saveSupplierProduct(this.supplierProduct)
          .then((res) => {
            if (res) {
              this.showSupplierProductDialog = !this.showSupplierProductDialog;
              let savedItem = res.data;
              const index = this.supplier.supplierProductList
                .map((d) => d.id)
                .indexOf(savedItem.id);
              if (index > -1) {
                this.supplier.supplierProductList.splice(index, 1, savedItem);
              } else {
                this.supplier.supplierProductList.unshift(savedItem);
              }
            }
          })
          .catch((err) => {
            console.log(err);
            if (err.response.data) {
              this.detailResponseError = err.response.data.message;
            }
          })
          .finally(() => {
            this.saveSupplierProductLoading = false;
          });
      }
    },
    editDetail(supplierProduct) {
      this.detailResponseError = "";
      this.supplierProduct = JSON.parse(JSON.stringify(supplierProduct));
      this.showSupplierProductDialog = !this.showSupplierProductDialog;
    },
    cancel() {
      this.showSupplierProductDialog = !this.showSupplierProductDialog;
    },

    showAccounts() {
      this.accountListDialog = !this.accountListDialog;
    },
    closeAccountDialog(account) {
      this.accountListDialog = !this.accountListDialog;
      if (account.id) {
        this.supplier.accountId = account.id;
        this.supplier.accountCode = account.code;
        this.supplier.accountName = account.name;
      }
    },

    getCurrencyExchange(currencyId) {
      this.currencyExchangeLoading = true;
      this.currencyExchangeError = "";
      let params = {
        currencyId: currencyId,
      };
      // get only first currency
      currencyExchangeRateService
        .getCurrencyExchangeRateList(params, 0, 1, "id,desc")
        .then((res) => {
          if (res.data.currencyExchangeRateList.length > 0) {
            let exchange = res.data.currencyExchangeRateList[0];
            if (exchange.id) {
              this.supplierProduct.currencyExchangeRateId = exchange.id;
              this.supplierProduct.exchangeRate = exchange.exchangeRate;
              this.calculateUnitCostMMK();
            }
          }
        })
        .catch((err) => {
          if (err.response.data) {
            this.currencyExchangeError = err.response.data.message;
          }
        })
        .finally(() => {
          this.currencyExchangeLoading = false;
        });
    },
    calculateUnitCostMMK() {
      if (this.supplierProduct.unitCost && this.supplierProduct.exchangeRate)
        this.supplierProduct.unitCostMMK = parseFloat(
          this.supplierProduct.exchangeRate * this.supplierProduct.unitCost
        ).toFixed(6);
    },
    changeStatus(statusFlag) {
      this.supplierProduct.status = statusFlag ? "ACTIVE" : "INACTIVE";
    },
  },
};
</script>

